
import debounce from 'lodash.debounce';
import throttle from 'lodash.throttle';

const methods = {
  debounce,
  throttle
};

class ResizeObserver {

  get type() { return this._type; }
  set type(value) {
    this._type = value;

    if(this._handlerWillTrigger) {
      this.observe();
    }
  }

  get wait() { return this._wait; }
  set wait(value) {
    this._wait = value;

    if(this._handlerWillTrigger) {
      this.observe();
    }
  }

  get leading() { return this._leading; }
  set leading(value) {
    this._leading = value;

    if(this._handlerWillTrigger) {
      this.observe();
    }
  }

  get trailing() { return this._trailing; }
  set trailing(value) {
    this._trailing = value;

    if(this._handlerWillTrigger) {
      this.observe();
    }
  }

  constructor() {
    this._listeners = [];
    this._type = 'debounce';
    this._wait = 30;
    this._leading = false;
    this._trailing = true;

    this._handlerWillTrigger = null;
  }

  observe() {

    if(this._handlerWillTrigger) {
      this.unobserve();
    }

    let handler;

    try {

      handler = methods[this._type](this._notify.bind(this), this._wait, {
        leading: this._leading,
        trailing: this._trailing
      });
    } catch(e) {

      handler = this._notify.bind(this);
    }

    window.addEventListener('resize', handler);

    this._handlerWillTrigger = handler;
  }

  unobserve() {

    if(this._handlerWillTrigger) {
      window.removeEventListener('resize', this._handlerWillTrigger);
      this._handlerWillTrigger = null;
    }
  }


  addListener(handler) {
    this._listeners.push(handler);
  }

  addListenerOnce(handler) {

    const once = () => {
      this.removeListener(once);
      handler();
    };

    this._listeners.push(once);
  }

  removeListener(handler) {

    for(let i = 0, iz = this._listeners.length; i < iz; i++) {
      const listener = this._listeners[i];

      if(listener === handler) {
        this._listeners.splice(i, 1);
        break;
      }
    }
  }

  removeAllListeners() {
    this._listeners = [];
  }

  _notify() {

    this._listeners.forEach((listener) => {
      listener();
    });
  }

}

export default new ResizeObserver();



// WEBPACK FOOTER //
// ./src/js/app/utils/ResizeObserver.js